import { render, staticRenderFns } from "./ExperienceInYears.vue?vue&type=template&id=6380209a&scoped=true&"
import script from "./ExperienceInYears.vue?vue&type=script&lang=js&"
export * from "./ExperienceInYears.vue?vue&type=script&lang=js&"
import style0 from "./ExperienceInYears.vue?vue&type=style&index=0&id=6380209a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6380209a",
  null
  
)

export default component.exports